import AirDatepicker from 'air-datepicker';
import SlimSelect from 'slim-select';

export function addListenetOnOutLinedInput(inputs) {
  for (let index = 0; index < inputs.length; index++) {
    const element = inputs[index];
    element.addEventListener('focus', function () {
      element.classList.add('_focus');
      element.parentElement.classList.add('_focus');
    });
    element.addEventListener('focusout', function () {
      if (element.value === '') {
        element.classList.remove('_focus');
        element.parentElement.classList.remove('_focus');
      }
    });
  }
}
export const changeInputFileHandler = (el, input) => {
  const labelTextEl = el.querySelector('.btn');
  const fileNameEl = el.querySelector('.input-file__name');
  // console.log(input.files);
  if (input.files.length > 0) {
    labelTextEl.textContent = 'Файл выбран';
    fileNameEl.textContent = input.files[0].name;
  } else {
    labelTextEl.textContent = 'Добавить';
    fileNameEl.textContent = '';
  }
};
document.addEventListener('DOMContentLoaded', () => {
  //text-field
  const inputFieldEl = document.querySelectorAll('._input');

  addListenetOnOutLinedInput(inputFieldEl);
  //select
  const selectEl = document.querySelectorAll('._select');
  if (selectEl.length > 0) {
    for (let index = 0; index < selectEl.length; index++) {
      const element = selectEl[index];
      new SlimSelect({
        select: element,
        showSearch: false,
        showContent: 'down',
        allowDeselectOption: true,
      });
      element.style.cssText = '';
      element.classList.add('_hide-select');
    }
  }
  //profile input
  const passInput = document.querySelectorAll('.profile-pass');
  if (passInput.length > 0) {
    const passShowBtn = document.querySelectorAll('.profile-pass__action');
    const passBtnClickHandler = (element) => {
      if (element.previousElementSibling.getAttribute('type') === 'password') {
        element.previousElementSibling.setAttribute('type', 'text');
      } else {
        element.previousElementSibling.setAttribute('type', 'password');
      }
    };
    for (let index = 0; index < passShowBtn.length; index++) {
      const element = passShowBtn[index];
      element.addEventListener('click', (e) => {
        e.preventDefault();
        passBtnClickHandler(element);
      });
    }
  }
  // input-file
  const inputFileEl = document.querySelectorAll('.input-file');

  if (inputFileEl.length > 0) {
    for (let index = 0; index < inputFileEl.length; index++) {
      const element = inputFileEl[index];
      element.querySelector('.input-file__input').addEventListener('input', (e) => {
        console.log('file change');
        changeInputFileHandler(element, e.target);
      });
    }
  }
  const datePickers = document.querySelectorAll('._date-picker');
  Array.prototype.forEach.call(datePickers, (item) => {
    item.oninput = function (e) {
      item.value = '';
      // item.setAttribute('disabled', 'disabled');
    };
    new AirDatepicker(item);
  });
});
